import React from 'react';
import { Icon } from './Icon.jsx';

/**
 * Slim utility bar above the step content: the dev-fill shortcut (dev builds
 * only) and the modal close button. Step titles live in <StepIntro>; back
 * navigation is a "← Voltar" link below each step's CTA. Renders nothing when
 * there is no button to show (e.g. inline mode outside dev).
 *
 * @param {{
 *   showClose?: boolean,
 *   onClose?: () => void,
 *   onDevFill?: () => void
 * }} props
 */
export function StepHeader({ showClose = true, onClose, onDevFill }) {
  const hasClose = showClose && onClose;
  if (!hasClose && !onDevFill) return null;

  return (
    <div className="tdw-step-header">
      {onDevFill && (
        <button
          type="button"
          className="tdw-btn-devfill"
          onClick={onDevFill}
          title="Preencher dados de teste (dev)"
          aria-label="Preencher dados de teste"
        >
          🧪
        </button>
      )}
      {hasClose && (
        <button
          type="button"
          className="tdw-btn-close"
          onClick={onClose}
          aria-label="Fechar"
        >
          <Icon name="close" size={18} />
        </button>
      )}
    </div>
  );
}
